// extracted by css-extract-rspack-plugin
export default {"chart":"Chart-module__chart___GWvbv","export":"Chart-module__export___TvQ5M"};